import {ModalValues} from "../../types";
import {ConfirmationModal, OverlayStyle} from "../../../../billingMenu/styles";
import {T2} from "../../../../../styles/titles";
import React, {useEffect, useState} from "react";
import {Input} from "../../../../billingMenu/signatures/loginSignatures/styles";
import {toast} from "react-toastify";

const PREDEFINED_PASSWORD = '3fFxAm8Ax|s_50|S&58g';

const dateFormatter = new Intl.DateTimeFormat("pt-BR", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric"
});

const parseToDate = (value: unknown): Date => {
  if (!value) return new Date();
  if (value instanceof Date) return value;
  const datePart = String(value).split(' ')[0];
  const [year, month, day] = datePart.split('-').map(Number);
  if (year && month && day) return new Date(year, month - 1, day);
  return new Date();
};

export const Modal: React.FC<ModalValues> = (props) => {
  const {isShowing, saveType, modalData, onConfirmation} = props;
  const [password, setPassword] = React.useState('');
  const [initialDate, setInitialDate] = useState<string>('');
  const [finalDate, setFinalDate] = useState<string>('');

  const handleConfirmation = (event:  React.MouseEvent<HTMLButtonElement>) => {
    const isConfirmed = event.currentTarget.value === '1';

    if (isConfirmed) {
      if (password === PREDEFINED_PASSWORD){
        onConfirmation?.(true);
      } else {
        toast.error("Senha incorreta!");
      }
    } else {
      onConfirmation?.(false);
    }
  }

  useEffect(() => {
    if(!isShowing) setPassword('')
  }, [isShowing]);

  useEffect(() => {
    if (!modalData) return;
    setInitialDate(dateFormatter.format(parseToDate(modalData.initialDate)));
    setFinalDate(dateFormatter.format(parseToDate(modalData.finalDate)));
  }, [modalData]);

  return (
    <>
      {isShowing && (
        <>
          <OverlayStyle onClick={() => onConfirmation?.(false)} />
          <ConfirmationModal>
            <T2>Confirmação</T2>
            <p>Deseja realmente salvar esses {saveType} no perído <strong>{initialDate}</strong> até <strong>{finalDate}</strong>?</p>
            <Input
              type="password"
              placeholder="Insira a senha"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <div style={{display: 'flex', gap: '10px',}}>
              <button
                onClick={handleConfirmation}
                value="0"
                style={{
                  flex: 1,
                  padding: '8px 16px',
                  backgroundColor: '#f44336',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                CANCELAR
              </button>
              <button
                onClick={handleConfirmation}
                value="1"
                style={{
                  flex: 1,
                  marginRight: '10px',
                  padding: '8px 16px',
                  backgroundColor: '#4CAF50',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                CONFIRMAR
              </button>
            </div>
          </ConfirmationModal>
        </>
      )}
    </>
  )
}
